import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  FeatureProducts,
  featuredProducts,
  titleTextColor,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/constant';
// import { sectionProps } from 'src/tools/constant';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';

import { Icon } from '@/src/tools/icon';
import { useHistory, useParams } from 'react-router-dom';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import styles from './css.module.less';
import { getEditableStatus } from '../../SalesChannelEditorAllProductPage-revamp/util';
// import { editable } from '@/src/tools/contentModulesFieldName';
// import { EPreviewSize } from '@/src/types/common/SalesChannel';

const colorN = [featuredProducts, titleTextColor];

const FP = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled, hasResetDot } = props;
  const h = useHistory();
  const { saleChannelUuid, contentUuid }: any = useParams();
  const onEdit = () => {
    h.push(
      `/salesChannel/editor/content/promotion/${saleChannelUuid}/${contentUuid}`,
    );
  };
  // const isPc = breakpoint === EPreviewSize.WIDE;

  // const handleOnResetTabletAndMobile = () => {
  //   const isTabletEditing = props.tabletForm.getFieldValue([
  //     `${FeatureProducts}_${editable}`,
  //   ]);
  //   const isMobileEditing = props.mobileForm.getFieldValue([
  //     `${FeatureProducts}_${editable}`,
  //   ]);
  //   if (isTabletEditing) {
  //     //props.handleOnSectionReset(buttonStyleResetFields, EPreviewSize.TABLET);
  //   } else {
  //     props.handleOnSectionReset([colorN], EPreviewSize.TABLET);
  //   }
  //   if (isMobileEditing) {
  //     //props.handleOnSectionReset(buttonStyleResetFields, EPreviewSize.MOBILE);
  //   } else {
  //     props.handleOnSectionReset([colorN], EPreviewSize.MOBILE);
  //   }
  // };

  const handleOnReset = () => {
    if (props.handleOnSectionReset) {
      props.handleOnSectionReset([colorN], breakpoint);
    }

    // if (isPc) {
    //   handleOnResetTabletAndMobile();
    // }
  };

  return (
    <Wrapper id={FeatureProducts} breakpoint={breakpoint}>
      <Field shouldUpdate>
        {(_, meta, { getFieldValue }) => {
          const is_editable = getEditableStatus(
            getFieldValue,
            FeatureProducts,
            breakpoint,
          );
          return (
            <BlockTitle
              id={FeatureProducts}
              title={getI18n('salesChannelContent.index.featureProduct')}
              breakpoint={breakpoint}
              onReset={() => {
                handleOnReset();
              }}
              onCopy={() => props.handleOnSectionCopy([colorN], breakpoint)}
              headerErrorDependencies={[]}
              validator={() => {
                return;
              }}
              dotsFunction={
                hasResetDot
                  ? [
                      {
                        onClick: () => {
                          handleOnReset();
                        },
                        key: 'Reset',
                        body: getI18n('general.resetSetting'),
                        isDangerous: true,
                      },
                    ]
                  : null
              }
              dotsDisabled={!is_editable}
            />
          );
        }}
      </Field>

      <div className={styles.content} onClick={onEdit}>
        <Icon type='iconarrow' className={styles.icon} />
        <span>{getI18n('salesChannelContent.index.editinPromotionPage')}</span>
      </div>
      <Section {...{ size: 'small', bottomBorder: false }}>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.titleTextColour')}>
          <Field shouldUpdate>
            {(props, meta, { getFieldValue }) => {
              const is_editable = getEditableStatus(
                getFieldValue,
                FeatureProducts,
                breakpoint,
              );
              return (
                <Field name={colorN}>
                  <ColorPicker disabled={disabled || !is_editable} />
                </Field>
              );
            }}
          </Field>
        </ItemWrapper>
      </Section>
    </Wrapper>
  );
};
export default FP;
